/**
 * API Configuration
 * 
 * Central configuration file for all API endpoints in the Prelude application.
 * Defines the base URL and all endpoint paths for:
 * - Authentication routes
 * - Service management
 * - Song operations
 * - User management
 * - Statistics and analytics
 */

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `/auth/login`,
    REGISTER: `/auth/register`,
    ME: `/auth/me`,
    LOGOUT: `/auth/logout`,
    REFRESH_TOKEN: `/auth/refresh-token`,
    FORGOT_PASSWORD: `/auth/forgot-password`,
    RESET_PASSWORD: `/auth/reset-password`,
    VERIFY_EMAIL: `/auth/verify-email`,
  },
  USERS: {
    BASE: `/users`,
    GET_USER: (id) => `/users/${id}`,
    UPDATE_USER: (id) => `/users/${id}`,
    DELETE_USER: (id) => `/users/${id}`,
    UPLOAD_AVATAR: (id) => `/users/${id}/avatar`,
    BIRTHDAYS_THIS_MONTH: `/users/birthdays/month`,
  },
  CHURCHES: {
    BASE: `/churches`,
    GET_CHURCH: (id) => `/churches/${id}`,
    UPDATE_CHURCH: (id) => `/churches/${id}`,
    DELETE_CHURCH: (id) => `/churches/${id}`,
    VERIFY: `/churches/verify`,
  },
  SERVICES: {
    BASE: `/services`,
    GET_SERVICE: (id) => `/services/${id}`,
    UPDATE_SERVICE: (id) => `/services/${id}`,
    DELETE_SERVICE: (id) => `/services/${id}`,
    UPCOMING: `/services/upcoming`,
    RECENT: `/services/recent`,
    MEMBER_STATUS: (serviceId, memberId) => `/services/${serviceId}/members/${memberId}`,
  },
  SONGS: {
    BASE: `/songs`,
    GET_SONG: (id) => `/songs/${id}`,
    UPDATE_SONG: (id) => `/songs/${id}`,
    DELETE_SONG: (id) => `/songs/${id}`,
    SEARCH: `/songs/search`,
    UPLOAD_AUDIO: (id) => `/songs/${id}/upload-audio`,
  },
  YOUTUBE: {
    BASE: `/youtube`,
    VIDEO_DETAILS: (videoId) => `/youtube/video-details/${videoId}`,
  },
  STATS: {
    BASE: `/stats`,
    DASHBOARD: `/stats/dashboard`,
    TEAM: `/stats/team`,
    SONGS: `/stats/songs`,
    SERVICES: `/stats/services`,
  },
  SUBSCRIPTIONS: {
    BASE: `/subscriptions`,
    CREATE: `/subscriptions/create`,
    STATUS: `/subscriptions/status`,
    BILLING: `/subscriptions/billing`,
    UPDATE_PAYMENT_METHOD: `/subscriptions/billing/payment-method`,
    GET_SUBSCRIPTION: (id) => `/subscriptions/${id}`,
    UPDATE_SUBSCRIPTION: (id) => `/subscriptions/${id}`,
    DELETE_SUBSCRIPTION: (id) => `/subscriptions/${id}`,
  },
  NOTIFICATIONS: {
    BASE: `/notifications`,
    GET_NOTIFICATIONS: `/notifications`,
    MARK_READ: (id) => `/notifications/${id}`,
    MARK_ALL_READ: `/notifications/mark-all-read`,
    DELETE: (id) => `/notifications/${id}`,
  },
  SONG_SUGGESTIONS: {
    TRENDY: `/song-suggestions/trendy`,
    RECOMMENDED: `/song-suggestions/recommended`,
    ADD_TO_LIBRARY: `/song-suggestions/add-to-library`,
  },
  BLOCKOUT_DATES: {
    BASE: `/blockout-dates`,
    GET_BLOCKOUT_DATE: (id) => `/blockout-dates/${id}`,
    UPDATE_BLOCKOUT_DATE: (id) => `/blockout-dates/${id}`,
    DELETE_BLOCKOUT_DATE: (id) => `/blockout-dates/${id}`,
    USER_BLOCKOUT_DATES: (userId) => `/blockout-dates/user/${userId}`,
    CHURCH_BLOCKOUT_DATES: `/blockout-dates/church`,
    UPCOMING: `/blockout-dates/upcoming`,
  },
};

export default API_ENDPOINTS;